import styled, { css } from 'styled-components'
import Select from 'react-select'
import { breakpoint } from '../layout/styles'
import { PanelContent, PanelHeading } from '../components/CollapsablePanel'

export const FilterGroup = styled.div`
  flex: 1 1 auto;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  display: none;
  @media ${breakpoint.desktop} {
    display: flex;
  }
`

export const Filter = styled(Select)`
  color: #000;
  margin-left: 12px;
  width: 200px;
  z-index: 2;
  .filter__control,
  .filter__menu {
    border-radius: 0;
    border: 1.5px #000 solid;
    font-size: 16px;
    line-height: 1.3;
    &:hover {
      border-color: rgba(0,0,0,0.5);
    }
  }

  .filter__control {
    box-shadow: none;
  }

  .filter__option {
    padding: 15px;
    color: #000;
    border-bottom: 1px #EAEAEA solid;
    &:last-child {
      border-bottom: 0;
    }
    &:hover,
    &:active {
      background: var(--primary);
      color: #fff;
    }
    &--is-focused {
      background: rgba(0,0,0,0.1);
      color: #000;
    }
    &--is-selected {
      background: #000;
      color: #fff;
    }
  }

  .filter__menu-list {
    padding: 0;
    width: calc(100% + 1px);
  }

  sup {
    font-size: 12px;
  }

  svg {
    fill: rgba(68, 68, 68, 1);
  }

  .filter__placeholder {
    color: #000;
    font-weight: bold;
  }

  .filter__single-value {
    font-weight: bold;
  }
`

export const FilterMobile = styled.button<any>`
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: var(--text);
  @media ${breakpoint.desktop} {
    display: none;
  }
  img {
    margin-right: 0.5rem;
  }
`
export const FilterContainer = styled.div<any>`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const FilterOverlay = styled.div<any>`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 6;
  background: var(--background);
  color: var(--text);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #000;
  padding: 1px;
  box-sizing: border-box;
  @media ${breakpoint.desktop} {
    display: none;
  }
  h3 {
    background: var(--primary);
    color: white;
    margin: 0;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    padding: 0.5rem 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    button {
      padding: 0;
      border: 0;
      background: transparent;
      width: 15px;
      height: 15px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        position: relative;
        left: -8px;
      }
    }
  }
`

export const FilterList = styled.div<any>`
  background: var(--background);
  flex: 1 1 auto;
  overflow-y: scroll;
  ${PanelHeading} {
    border-top: 0;
    border-bottom-color: black;
    border-bottom-width: 1.5px;
    color: black;
  }
  ${PanelContent} {
    border-bottom: 0;
  }
`

export const FilterOption = styled.button<any>`
  display: block;
  border: 0;
  width: 100%;
  background: transparent;
  text-align: left;
  padding: 1.5rem;
  border-bottom: 1px #000 solid;
  &:last-child {
    border-bottom-width: 1.5px;
  }
  color: black;
  font-size: 14px;
  &:first-child {
    border-top: 1px #000 solid;
  }
  ${props => props.checked && css`
    background: url(/images/checked.svg) no-repeat scroll calc(100% - 28px) center;
  `}
  &:active {
    background: var(--primary);
    color: white;
  }
`

export const FilterActions = styled.div<any>`
  display: flex;
  background: var(--background);
`

export const FilterAction = styled.button<any>`
  padding: 1rem 0;
  width: 50%;
  background: transparent;
  border: 0;
  font-weight: 600;
  font-size: 16px;
  color: var(--primary);
  border-top: 1.5px var(--primary) solid;
  &:last-child {
    background: var(--primary);
    color: white;
  }
`